export const carsOfTheYears = [
  {
    year: 2024,
    url: '/coty-2024/winners/',
  },
  {
    year: 2023,
    url: '/coty-2023/winners/',
  },
  {
    year: 2022,
    url: '/coty-2022/winners/',
  },
  {
    year: 2021,
    url: '/articles/features/oneshift-car-of-the-year-the-best-cars-of-2021',
  },
  {
    year: 2020,
    url: '/articles/features/car-of-the-year-the-best-cars-of-2020',
  },
  {
    year: 2019,
    url: '/articles/features/car-of-the-year-2019-category-winners-revealed',
  },
  {
    year: 2018,
    url: '/articles/features/car-of-the-year-2018-unveiled-skoda-kodiaq-20-tsi-style',
  },
  {
    year: 2017,
    url: '/articles/features/car-of-the-year-2017-unveiled-the-range-rover-velar',
  },
  {
    year: 2016,
  },
  {
    year: 2015,
    url: '/articles/features/oneshift-2015-car-of-the-year-winners-announced',
  },
  {
    year: 2014,
    url: '/articles/features/oneshift-car-of-the-year-2014-results-are-out',
  },
  {
    year: 2013,
    url: '/articles/features/oneshift-car-of-the-year-2013-results',
  },
  {
    year: 2012,
    url: '/articles/features/oneshifts-car-of-the-year-2012-winners-unveiled',
  },
  {
    year: 2011,
    url: '/articles/features/car-of-the-year-2011',
  },
  {
    year: 2010,
    url: '/articles/features/car-of-the-year-2010-all-the-class-winners',
  },
  {
    year: 2009,
    url: '/articles/features/car-of-the-year-2009',
  },
  {
    year: 2008,
    url: '/articles/features/oneshiftcom-car-of-the-year-awards-2008',
  },
];

carsOfTheYears.sort((a, b) => a.year - b.year);

export const T = '';
